import React from 'react';
import { useTranslation } from "react-i18next";
import HeroSection from '../../components/sections/HeroSection';
import FooterSection from '../../components/sections/FooterSection';
import DividersInfoSection from '../../components/sections/DividersInfoSection';
import FaqAccordionsSection from '../../components/sections/FaqAccordionsSection';
import FactsAndStatsSection from '../../components/sections/FactsAndStatsSection';
import BigTinyIntroSection from '../../components/sections/BigTinyIntroSection';
import ParallaxCallSection from '../../components/sections/ParallaxCallSection';

function ShymkentCityPage(props) {

    var { t } = useTranslation();

    var faqItems = [
        { question: "What documents are required?", answer: "Passport valid for at least 6 months, visa application form, passport photos, proof of accommodation, and travel insurance are standard requirements." },
        { question: "How long does processing take?", answer: "Standard processing usually takes up to 5 working days, while express processing can be completed in 48 hours depending on consular workload." },
        { question: "Can business delegations apply?", answer: "Yes, corporate visa packages are available for delegations, including bulk submissions, account-based invoicing, and consolidated document delivery." },
        { question: "Is visa on arrival available?", answer: "Visa on arrival is limited to specific cases. Pre-application ensures guaranteed entry and avoids administrative delays at the border." }
    ];

    return (
        <>
            <HeroSection
                isExpectingAnimations={true}
                i18nTitleKey="infopages.cities.shymkent.title"
                i18nParagraphKey="infopages.cities.shymkent.paragraph1"
                i18nCallToActionKey="infopages.cities.shymkent.cta"
                backgroundImageUrl="https://i.ytimg.com/vi/ueqmuN11IoM/maxresdefault.jpg"
            />
                
            <div className='uk-container uk-section'>
                <BigTinyIntroSection
                    Big="Shymkent, one of Kazakhstan's largest cities, is a vibrant metropolis located in the southern part of the country. Known for its rich cultural heritage and diverse population, Shymkent serves as a major economic and industrial hub. The city boasts a blend of modern infrastructure and traditional architecture, reflecting its historical significance as a key trading center along the Silk Road. Visitors to Shymkent can explore its bustling markets, enjoy local cuisine, and experience the warm hospitality of its residents."
                    Tiny="In addition to its economic importance, Shymkent is also a gateway to several natural attractions, including the nearby Aksu-Zhabagly Nature Reserve, which is renowned for its biodiversity and scenic landscapes. The city's parks and recreational areas provide residents and visitors with ample opportunities for outdoor activities. With its dynamic atmosphere and cultural richness, Shymkent continues to grow as a significant urban center in Kazakhstan."
                />
            </div>

            <ParallaxCallSection
                URL="https://dynamic-media-cdn.tripadvisor.com/media/photo-o/11/38/a8/b6/getlstd-property-photo.jpg?w=1200&h=1200&s=1"
                headline="Feel the Warmth of Shymkent"
                callToAction="Apply for your visa with Jai and explore southern Kazakhstan’s most welcoming city — a gateway to tradition, cuisine, and sunlit adventure."
            />

            {/* Quick Facts / Statistics */}
            <FactsAndStatsSection
                sectionTitle="Quick Facts"
                stat1="90%"
                fact1="Visa approval rate"
                stat2="635+"
                fact2="Clients served"
                stat3="14"
                fact3="Days processing time"
                stat4="1960"
                fact4="Year city founded"
            />

            {/* FAQ Accordion */}
            <FaqAccordionsSection
                items={faqItems}
            />

            <div className='uk-container'>
                {/* Infosection with shitloads of dividers */}
                <DividersInfoSection />
            </div>

            <FooterSection />
        </>
    );
}

export default ShymkentCityPage;